import { Component, OnInit } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { SignOffActivity } from 'src/app/models/activities/sign-off-activity';
import { WorkflowApplicationSignOff } from 'src/app/models/workflow-application-sign-off';

@Component({
  selector: 'wm-sign-off-activity-view',
  templateUrl: './sign-off-activity-view.component.html',
  styleUrls: ['./sign-off-activity-view.component.css'],
  standalone: false
})
export class SignOffActivityViewComponent extends ActivityView implements OnInit {
  activity: SignOffActivity;
  signOff: WorkflowApplicationSignOff;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.activity && this.activity.model) {
      this.signOff = this.activity.model.signOff;
    }
  }

  getStatusClass(): string {
    if (!this.signOff || !this.signOff.status) {
      return 'badge bg-secondary';
    }

    switch (this.signOff.status) {
      case 1: // Approved
        return 'badge bg-success';
      case 2: // Disapproved
        return 'badge bg-danger';
      case 3: // ApprovedWithCondition
        return 'badge bg-warning';
      case 4: // NotApplicable
        return 'badge bg-secondary';
      case 5: // Incomplete
        return 'badge bg-info';
      default: // Pending
        return 'badge bg-primary';
    }
  }
}
